import ApiHelper from '../ApiHelper.js';

const FontApiUrl = "/api/fonts";
const FontPairApiUrl = "/api/fontpairs"

function buildFontFormData(font, { files = [], fontsToDelete = [] } = {}) {
    const formData = new FormData();
    const attributes = Array.isArray(font.attributes)
        ? [...font.attributes].sort().join(",")
        : font.attributes || "";

    formData.append("name", (font.name || "").trim());
    formData.append("repository", font.repository || "");
    formData.append("category", font.category || "");
    formData.append("attributes", attributes);
    formData.append("repositoryType", font.repositoryType || "");
    formData.append("urlParams", font.urlParams ?? "");

    const deletedUrls = Array.from(fontsToDelete || [])
        .map((fontToDelete) => typeof fontToDelete === "string" ? fontToDelete : fontToDelete?.url)
        .filter(Boolean);
    if (deletedUrls.length) {
        formData.append("fontsToDelete", deletedUrls.join(","));
    }

    Array.from(files || []).filter(Boolean).forEach((file) => formData.append("fonts", file));

    return formData;
}

export default {

    //FONTS
    //get
    getFonts(query) {
        return ApiHelper.get(FontApiUrl + query);
    },
    //post multipart
    updateFont(id, font, options = {}) {
        return ApiHelper.postMultipart(
            FontApiUrl + "/" + id,
            buildFontFormData(font, options),
        );
    },
    //delete
    deleteFont(id) {
        return ApiHelper.delete(FontApiUrl + "/" + id);
    },


    //FONT-PAIRS
    //get
    getFontPairs(query) {
        return ApiHelper.get(FontPairApiUrl + query);
    },
    //post
    createFontPair(data) {
        return ApiHelper.post(FontPairApiUrl, data)
    },
    //put
    updateFontPair(id, fontPair) {
        return ApiHelper.put(FontPairApiUrl + "/" + id, fontPair);
    },
    //delete
    deleteFontPair(id) {
        return ApiHelper.delete(FontPairApiUrl + "/" + id);
    }
}
